"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
} // TODO remove negative margin from grid in semantic


var Footer = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Footer, _React$Component);

  var _super = _createSuper(Footer);

  function Footer() {
    (0, _classCallCheck2["default"])(this, Footer);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Footer, [{
    key: "getContainerClassNames",
    value: function getContainerClassNames() {
      var _this$props = this.props,
          className = _this$props.className,
          backgroundColor = _this$props.backgroundColor;
      return this.isInColorPalette() ? "".concat(className, " footer-container-").concat(backgroundColor) : '';
    }
  }, {
    key: "getContainerStyle",
    value: function getContainerStyle() {
      var backgroundColor = this.props.backgroundColor;
      return !this.isInColorPalette() && backgroundColor !== 'none' ? {
        backgroundColor: backgroundColor
      } : {};
    }
  }, {
    key: "isInColorPalette",
    value: function isInColorPalette() {
      var backgroundColor = this.props.backgroundColor;
      return backgroundColor === 'primary' || backgroundColor === 'secondary';
    }
  }, {
    key: "renderFooterColumns",
    value: function renderFooterColumns() {
      var _this$props2 = this.props,
          columns = _this$props2.columns,
          verticalAlign = _this$props2.verticalAlign,
          horizontalAlign = _this$props2.horizontalAlign;
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
        columns: columns.length,
        verticalAlign: verticalAlign,
        textAlign: horizontalAlign,
        stackable: true
      }, columns.map(function (column, index) {
        return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
          key: index
        }, column);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: this.getContainerClassNames(),
        style: this.getContainerStyle()
      }, this.renderFooterColumns());
    }
  }]);
  return Footer;
}(_react["default"].Component);

exports["default"] = Footer;
Footer.propTypes = {
  backgroundColor: _propTypes["default"].string,
  className: _propTypes["default"].string,
  columns: _propTypes["default"].arrayOf(_propTypes["default"].element),
  horizontalAlign: _propTypes["default"].oneOf(['left', 'center', 'right']),
  verticalAlign: _propTypes["default"].oneOf(['top', 'middle', 'bottom'])
};
Footer.defaultProps = {
  backgroundColor: '',
  className: '',
  columns: [],
  horizontalAlign: 'center',
  verticalAlign: 'middle'
};
Footer.propOptions = {
  backgroundColor: ['primary', 'secondary', 'default']
};